import { CheckIcon } from '@langchain/untitled-ui-icons';

import { Text } from '@/design-system';
import { cn } from '@/design-system/utils/cn';
import {
  UserOnboardingStateFieldEnum,
  UserOnboardingStateResponse,
} from '@/types/schema';

interface WelcomeToLangSmithProps {
  onboardingState: UserOnboardingStateResponse;
}

export function WelcomeToLangSmith({
  onboardingState,
}: WelcomeToLangSmithProps) {
  const onboardingStateFields = UserOnboardingStateFieldEnum.options;

  const completedOnboardingStateFields = onboardingStateFields.filter(
    (field) => !!onboardingState[field]
  );

  return (
    <div>
      <Text variant="h4" weight="medium" className="mb-6 tracking-normal">
        LET'S GET STARTED
      </Text>

      <Text
        variant="h1"
        weight="normal"
        className="mb-8 text-5xl leading-[1.1] -tracking-[0.05em]"
      >
        {!!onboardingState.tracing_completed_at &&
        !!onboardingState.lgstudio_completed_at &&
        !!onboardingState.playground_completed_at
          ? "You're all set"
          : 'Welcome to LangSmith'}
      </Text>

      <div className="flex items-center gap-3">
        <div className="flex gap-1.5">
          {onboardingStateFields.map((field, i) => (
            <div
              key={field}
              className={cn(
                'size-5 rounded-sm border border-secondary',
                i < completedOnboardingStateFields.length &&
                  'flex items-center justify-center border-none bg-brand-primary'
              )}
            >
              {i < completedOnboardingStateFields.length && (
                <CheckIcon className="size-4 text-white" />
              )}
            </div>
          ))}
        </div>

        <p className="text-sm font-medium text-secondary">
          {completedOnboardingStateFields.length}/{onboardingStateFields.length}
        </p>
      </div>
    </div>
  );
}
